// extracted by mini-css-extract-plugin
export default {"container":"Co-z","bubbleNav":"Do-z","graphic":"Eo-z","contact":"Fo-z"};